module.exports = __webpack_public_path__ + "static/media/67.eae2b857.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/67.png
// module id = 641
// module chunks = 0